<script>
    import { onMount } from "svelte";

    import { user, isMobile } from "../../stores";

    import {
        SvelteTable,
        SearchInput,
        SearchSelect,
        PageLoading,
        TableElementEditableStatus,
        Button,
    } from "../../Components/Common/index.svelte";

    import { apiMethods } from "../../Services/index.svelte";

    import {
        decodeSearchParams,
        encodeSearchParams,
        getDoctorStatus,
        getText,
        getTitle,
        goBack,
        goToURL,
        replaceURL,
        showError,
    } from "../../Utils/utilFunctions.svelte";

    import { doctorStatus } from "../../Utils/utilEnums.svelte";

    import { checkIfShowTab } from "../../Utils/utilRoute.svelte";

    import TableFooter from "../../Components/Layout/Table/TableFooter.svelte";

    export let params = {};

    $: if ($user.role == 100)
        columns.splice(3, 0, {
            key: "group",
            title: "Group",
            headerClass: "text-left pl-4 text-[14px] cursor-default",
            class: "text-left pl-4 text-[14px] cursor-pointer",
            value: (v) =>
                v.groupName && v.groupId ? getText(v.groupName) : "-",
        });

    $: isEnableCreateDoctor = $user.role == 100 || $user.role == 80;

    let isGettingAccount = false,
        returnAccountArr = [],
        filters = { status: "0,1,5" },
        page = 0,
        pageSize = 25,
        count,
        checkboxString = "",
        selectedAccounts = [],
        selectedAccountsIdArray = [];

    const columns = [
        {
            key: "selected?",
            title: "",
            class: "",
            headerClass: "toggleSelectAllHeader text-center ml-3 rounded-tl-xl",
            value: (v) => v.selected,
            renderValue: (v) =>
                `<input type="checkbox" class="checkbox checkbox-primary checkbox-xs ml-3 text-white cursor-pointer" name="selectCheckBox" id="selectCheckBoxId${v.id}">`,
            sortable: false,
            csvExportHidden: true,
        },
        {
            key: "id",
            title: "Doctor ID",
            value: (v) => getText(v.id),
            // min width for id with sort in one line
            headerClass:
                "text-left pl-4 text-[14px] sortable-header-decoration min-w-[100px]",
            class: "text-left pl-4 text-[14px] cursor-pointer",
        },
        {
            key: "name",
            title: "Name",
            value: (v) => getFullName(v),
            headerClass:
                "text-left pl-4 text-[14px] sortable-header-decoration",
            class: "text-left pl-4 text-[14px] cursor-pointer",
        },
        {
            key: "preferredName",
            title: "Preferred Name",
            value: (v) => (v.preferredName ? getText(v.preferredName) : "-"),
            headerClass: "text-left pl-4 text-[14px] cursor-default",
            class: "text-left pl-4 text-[14px] cursor-pointer",
        },
        {
            key: "phone",
            title: "Phone No.",
            value: (v) => v.phone,
            headerClass: "text-left pl-4 text-[14px] cursor-default",
            class: "text-left pl-4 text-[14px] cursor-pointer",
        },
        {
            key: "providersNumber",
            title: "Providers Number(s)",
            renderValue: (v) =>
                _renderListComponent(v.providers, "providersNumber"),
            csvContent: (v) =>
                _renderListComponent(v.providers, "providersNumber", true),
            headerClass: "text-left pl-4 text-[14px] cursor-default",
            class: "text-left pl-4 text-[14px] cursor-pointer flex flex-col",
        },
        {
            key: "users",
            title: "Users",
            renderValue: (v) => _renderListComponent(v.users, "users"),
            csvContent: (v) => _renderListComponent(v.users, "users", true),
            headerClass: "text-left pl-4 text-[14px]",
            class: "text-left pl-4 text-[14px] cursor-pointer",
        },
        {
            key: "status",
            title: "Status",
            headerClass: "text-left px-3 cursor-default rounded-tr-xl",
            class: "text-left px-3 w-[10%]",
            csvContent: (v) => getDoctorStatus(v.status),
            renderComponent: {
                component: TableElementEditableStatus,
                props: {
                    type: "doctor",
                    onFinish: () =>
                        loadDoctors(
                            page * pageSize,
                            pageSize,
                            _getSearchParams(),
                        ),
                },
            },
        },
    ];

    const sortableHeaderKeys = ["id", "name"];

    $: _getCheckboxString(selectedAccountsIdArray);
    $: if (selectedAccounts.length >= 0 && returnAccountArr.length > 0) {
        selectedAccountsIdArray = selectedAccounts.map((account) => account.id);
        _updateHeaderIcon();
    }

    onMount(() => {
        if (!checkIfShowTab($user.role, params.root)) {
            goBack();
            return;
        }

        if (params.query) updateSearchParamsByQuery(params.query);

        loadDoctors(page * pageSize, pageSize, _getSearchParams());

        if (params.query) updateCheckboxByQuery(params.query);
    });

    const createDoctor = () => goToURL("/Account/create/new");

    const updateSearchParamsByQuery = (query) => {
        const arr = decodeSearchParams(query).split("&");

        if (arr.length) {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].includes("page="))
                    page = Number(arr[i].split("=")[1]);

                if (arr[i].includes("size="))
                    pageSize = Number(arr[i].split("=")[1]);

                if (arr[i].includes("sort="))
                    filters.sort = arr[i].split("=")[1];

                if (arr[i].includes("search="))
                    filters.accountName = arr[i].split("=")[1].toString();

                if (arr[i].includes("status="))
                    filters.status = arr[i].split("=")[1];
            }
            updateURL();
        }
    };

    const updateCheckboxByQuery = (query) => {
        const arr = query.split("&");
        if (arr.length) {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].includes("check=")) {
                    const checkArr = arr[i].split("=")[1].split(",");
                    checkArr.map((ca) => {
                        if (
                            !selectedAccounts.some(
                                (acc) => acc.id == Number(ca),
                            )
                        ) {
                            let newAccountItem = { id: Number(ca) };
                            selectedAccounts = [
                                ...selectedAccounts,
                                newAccountItem,
                            ];
                            const checkbox = document.getElementById(
                                `selectCheckBoxId${ca}`,
                            );
                            if (checkbox) checkbox.checked = true;
                        }
                    });
                }
            }
        }
    };

    const loadDoctors = async (start, limit, params) => {
        isGettingAccount = true;

        if (params.sort) params.sort = params.sort.toLowerCase();

        await apiMethods.getMethod
            .getAccount(start, limit, params)
            .then((res) => _handleAccounts(res))
            .then(() => _updateHeaderSortIcon());

        isGettingAccount = false;
    };

    const handleFilterSelect = () => {
        page = 0;
        selectedAccounts = [];

        updateURL();

        loadDoctors(0, pageSize, _getSearchParams());
    };

    const onPageChange = (e) => {
        page = Number(e.detail.page);

        updateURL();

        loadDoctors(
            Number(e.detail.firstDataIndex),
            pageSize,
            _getSearchParams(),
        );
    };

    const onPageSizeChange = (newPageSize) => {
        pageSize = newPageSize;
        page = 0;

        updateURL();

        loadDoctors(0, newPageSize, _getSearchParams());
    };

    const handleClickCell = ({ target: { className } }, rowData, key) => {
        if (key == "selected?") _addSelectedAccount(rowData);
        else if (key !== "status" && rowData.status != 9)
            goToURL(`/Account/view/${rowData.id}`);
    };

    const handleClickCol = ({ target: { className } }, colData, key) => {
        if (key == "selected") _updateCheckBox();
        else if (sortableHeaderKeys.includes(key)) {
            if (filters.sort == key) filters.sort = `${key}Desc`;
            else filters.sort = key;
            updateURL();
            loadDoctors(0, pageSize, _getSearchParams());
        }
    };

    const generateSelectAll = () => {
        const selectAllHeader = document.getElementsByClassName(
            "toggleSelectAllHeader",
        )[0];
        const tag = document.createElement("input");
        tag.type = "checkbox";
        tag.className =
            "toggleSelectAll text-center hover:cursor-pointer checkbox checkbox-primary checkbox-xs bg-white ml-3 mt-2";
        tag.id = "toggleSelectAll";
        tag.onclick = () => {
            toggleSelectAll();
        };
        if (selectAllHeader) selectAllHeader.appendChild(tag);
    };

    const toggleSelectAll = () => {
        const selectAllCheckBox = document.getElementById("toggleSelectAll");
        if (selectAllCheckBox.className.includes("selectedAll")) {
            selectedAccounts = [];
            _updateCheckBox();
        } else {
            returnAccountArr.forEach((account) => {
                if (!selectedAccountsIdArray.includes(account.id)) {
                    _addSelectedAccount(account);
                }
            });
        }
    };

    const updateURL = () => {
        if (checkboxString)
            replaceURL(
                `/Account/page=${page}&size=${pageSize}&check=${checkboxString}${_getParamsString()}`,
            );
        else
            replaceURL(
                `/Account/page=${page}&size=${pageSize}${_getParamsString()}`,
            );
    };

    const getFullName = (v) => {
        return `${getTitle(v.title)} ${v.firstName}${
            v.middleName ? " " + v.middleName : ""
        }${v.lastName ? " " + v.lastName : ""}`;
    };

    // HELPER FUNCTIONS
    const _handleAccounts = async (res) => {
        if (res.error) showError(res.error);
        else {
            returnAccountArr = res.results;
            count = res.total;
        }
        setTimeout(() => {
            generateSelectAll();
            _updateCheckBox();
        }, 1);
    };

    const _renderListComponent = (arr, str, isCsvContent = false) => {
        const result = [];
        let component;
        if (arr && arr.length) {
            arr.forEach((target) => {
                switch (str) {
                    case "providersNumber":
                        component = component = isCsvContent
                            ? `${target.number} (${target.location})`
                            : `<div class="showProvider${target.id}">${target.number} (${target.location})</div>`;
                        break;
                    case "users":
                        component = isCsvContent
                            ? `${target.fullName} (${target.email})`
                            : `<div class="showProvider${target.id}">${target.fullName} (${target.email})</div>`;
                        break;
                    default:
                        break;
                }
                result.push(component);
            });
        }
        return result.join(isCsvContent ? "\r\n" : "").toString();
    };

    const _addSelectedAccount = (data) => {
        if (selectedAccounts.some((item) => item.id === data.id)) {
            selectedAccounts = selectedAccounts.filter(
                (item) => item.id !== data.id,
            );
        } else {
            selectedAccounts = [...selectedAccounts, data];
            const checkbox = document.getElementById(
                `selectCheckBoxId${data.id}`,
            );
            if (checkbox) checkbox.checked = true;
        }
    };

    const _updateHeaderIcon = () => {
        const headerIcon = document.getElementById("toggleSelectAll");
        if (!headerIcon) {
            return;
        }
        if (selectedAccounts.length === 0) {
            headerIcon.className =
                "toggleSelectAll text-center hover:cursor-pointer checkbox checkbox-primary checkbox-xs bg-white mt-2 ml-3 selectedNone";
            headerIcon.checked = false;
            headerIcon.style = "";
        } else if (
            returnAccountArr.every((statement) =>
                selectedAccountsIdArray.includes(statement.id),
            )
        ) {
            headerIcon.style.cssText = "";
            headerIcon.className =
                "toggleSelectAll text-center hover:cursor-pointer checkbox checkbox-primary checkbox-xs bg-white mt-2 ml-3 selectedAll";
            headerIcon.checked = true;
        } else {
            headerIcon.className =
                "toggleSelectAll text-center hover:cursor-pointer checkbox checkbox-primary checkbox-xs bg-white mt-2 ml-3 appearance-none selectedPartial";
            headerIcon.checked = false;
            headerIcon.style.cssText =
                "border: solid #270053; border-width: 4px; padding: 4px; border-radius: 5px; background-color: white; cursor: pointer; margin: 0.5rem 0 0 0.75rem";
        }
    };

    const _updateCheckBox = () => {
        setTimeout(() => {
            returnAccountArr.forEach((acc) => {
                const checkbox = document.getElementById(
                    `selectCheckBoxId${acc.id}`,
                );
                if (checkbox) {
                    if (selectedAccountsIdArray.includes(acc.id)) {
                        document.getElementById(
                            `selectCheckBoxId${acc.id}`,
                        ).checked = true;
                    } else
                        document.getElementById(
                            `selectCheckBoxId${acc.id}`,
                        ).checked = false;
                }
            });
            _updateHeaderIcon();
        }, 10);
    };

    const _getSearchParams = () => {
        let params = {};
        if (filters.sort) params.sort = filters.sort;

        if (filters.accountName) params.search = filters.accountName;

        if (filters.status || filters.status == Number(0))
            params["filter[status]"] = filters.status;

        return params;
    };

    const _getParamsString = () => {
        let str = "";
        const params = _getSearchParams();

        if (params) {
            if (params.sort) str += `&sort=${params.sort}`;

            if (params.search) str += `&search=${params.search}`;

            if (
                params["filter[status]"] ||
                params["filter[status]"] == Number(0)
            )
                str += `&status=${params["filter[status]"]}`;
        }

        return encodeSearchParams(str);
    };

    const _getCheckboxString = (arr) => {
        if (arr.length) checkboxString = arr.toString();
        else checkboxString = "";

        updateURL();
    };

    const _updateHeaderSortIcon = () => {
        let thRow = document.getElementsByTagName("th");
        const params = _getSearchParams();

        if (params) {
            setTimeout(() => {
                const upSpan = document.createElement("span");
                const downSpan = document.createElement("span");
                upSpan.innerHTML = `<i class="fas fa-sort-alpha-down" />`;
                upSpan.style = "font-size: 10px;";
                downSpan.innerHTML = `<i class="fas fa-sort-alpha-up-alt" />`;
                downSpan.style = "font-size: 10px;";

                Array.from(thRow).forEach((row) => {
                    if (
                        (params.sort == "id" &&
                            row.childNodes[0].data == "Doctor ID") ||
                        (params.sort == "name" &&
                            row.childNodes[0].data == "Name")
                    )
                        row.appendChild(upSpan);
                    else if (
                        (params.sort == "idDesc" &&
                            row.childNodes[0].data == "Doctor ID") ||
                        (params.sort == "nameDesc" &&
                            row.childNodes[0].data == "Name")
                    )
                        row.appendChild(downSpan);
                });
            }, 0);
        }
    };
</script>

<div class="flex flex-col flex-1 gap-y-4">
    <div class="flex flex-col gap-y-4 flex-0">
        <div class="flex flex-row justify-between flex-wrap">
            <div class="flex gap-4 flex-wrap">
                <SearchInput
                    bind:value={filters.accountName}
                    title="Search"
                    inputFunc={handleFilterSelect}
                    isLong
                />

                <SearchSelect
                    title="Status"
                    bind:value={filters.status}
                    onChangeFunc={handleFilterSelect}
                    isLong
                >
                    <option value="0,1,5"> Active, Demo & New </option>
                    {#each doctorStatus as op}
                        <option value={op.id.toString()}>{op.type}</option>
                    {/each}
                    <option value={null}>All Except deleted</option>
                </SearchSelect>
            </div>

            {#if isEnableCreateDoctor}
                <Button clickFunc={createDoctor}>Create Doctor</Button>
            {/if}
        </div>
    </div>

    <div class={$isMobile ? "h-auto w-minus48" : "relative flex-1"}>
        {#if isGettingAccount}
            <PageLoading />
        {:else}
            <div
                class={$isMobile
                    ? "overflow-x-auto overflow-y-visible"
                    : "overflow-y-auto absolute inset-0"}
            >
                <SvelteTable
                    {columns}
                    rows={returnAccountArr}
                    clickCellFunc={({ detail: { event, row, key } }) => {
                        handleClickCell(event, row, key);
                    }}
                    clickColFunc={({ detail: { event, row, key } }) => {
                        handleClickCol(event, row, key);
                    }}
                />
            </div>
        {/if}
    </div>

    <TableFooter
        {page}
        {pageSize}
        {count}
        showSelected
        selectedCount={selectedAccounts.length}
        tableData={returnAccountArr}
        {onPageChange}
        {onPageSizeChange}
        csvConfig={{
            columns,
            data: returnAccountArr,
            fileName: "Doctors",
            allDataApi: async () =>
                await apiMethods.getMethod.getAccount(
                    0,
                    999999,
                    _getSearchParams(),
                ),
        }}
    />
</div>
